import React from 'react';
import * as S from './visaoItemGrupo.styled';

function VisaoItemGrupo({ titulo, extra, campos, children, emLinha }) {
  const visiveis = (campos || []).filter(
    campo => campo.valor !== null && campo.valor !== undefined && campo.valor !== ''
  );

  if (!visiveis.length && !children) return null;

  function renderCampos() {
    if (emLinha) {
      return (
        <S.Faixa>
          {visiveis.map(campo => (
            <S.Par key={campo.rotulo}>
              <S.RotuloLinha>{campo.rotulo}</S.RotuloLinha>
              <S.ValorLinha>{campo.valor}</S.ValorLinha>
            </S.Par>
          ))}
        </S.Faixa>
      );
    }

    return (
      <S.Grade>
        {visiveis.map(campo => (
          <S.Campo key={campo.rotulo} $cheia={campo.cheia}>
            <S.Rotulo>{campo.rotulo}</S.Rotulo>
            <S.Valor>{campo.valor}</S.Valor>
          </S.Campo>
        ))}
      </S.Grade>
    );
  }

  return (
    <S.Painel>
      <S.Cabecalho>
        <S.Titulo>{titulo}</S.Titulo>
        {extra ? <S.Selo>{extra}</S.Selo> : null}
      </S.Cabecalho>
      <S.Corpo>
        {children || renderCampos()}
      </S.Corpo>
    </S.Painel>
  );
}

export default VisaoItemGrupo;
